// extracted by mini-css-extract-plugin
module.exports = {"root":"SubBar-root-01545d990c7a860e0226a06b9123eda5"};